<template>
  <v-card flat>
    <v-layout
      align-center
      justify-space-around
      row
      wrap
    >
      <v-flex
        xs10
        sm4
        md4
        lg4
        xl4
        class="font-weight-light"
        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'body-2': $vuetify.breakpoint.smAndDown}"
      >
        <v-img
          max-height="500px"
          max-width="400px"
          :src="photoSource"
        />
      </v-flex>
      <v-flex
        xs11
        sm6
        md7
        lg8
        xl8
        class="font-weight-light"
        :class="{'body-2': $vuetify.breakpoint.mdAndUp, 'body-2': $vuetify.breakpoint.smAndDown}"
      >
        <h2>{{ nameAndCredentials }} | {{ position }}</h2>
        <p>
          <slot />
        </p>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import Vue from 'vue';
export default {
  name: 'TeamMemberCard',
  components: {
  },
  props: {
      'position': {
        type: String,
        required: true
      },
      'nameAndCredentials': {
        type: String,
        required: true
      },
      'photoSource': {
        type: String,
        required: true
      },
  },
  data: function() {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>
